import { render, staticRenderFns } from "./OrganizationCenter.vue?vue&type=template&id=3b478a44&"
import script from "./OrganizationCenter.vue?vue&type=script&lang=js&"
export * from "./OrganizationCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports